// extracted by mini-css-extract-plugin
module.exports = {"footer":"MembersModal_footer__i6k3g","members-list":"MembersModal_members-list__3cPVy"};